import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import "../layout/Spinner.css";
import { Dropdown } from "semantic-ui-react";
import { useState, useEffect } from "react";
let sportList = null;
const AdvocatesDropdown = (props) => {
  const [playerOptions, setPlayerOptions] = useState([]);
  const [games, setGames] = useState([]);
  const athletes = props.athletes;

  useEffect(() => {
    if (athletes) {
      setGames(athletes);
    }
  }, [athletes]);

  useEffect(() => {
    setPlayerOptions(
      Object.keys(games)
        .filter((index) => index !== "id")
        .map((keyId, i) => {
          return {
            key: i,
            text: games[keyId].name,
            value: games[keyId].id,
          };
        })
    );
  }, [games]);

  sportList = (
    <Dropdown
      {...props}
      options={playerOptions}
      selection
      fluid
      placeholder={props.placeholder}
      name={props.name}
      onChange={props.onChange}
      search
      defaultValue={props.defaultValue}
    />
  );
  if (!isLoaded(athletes)) {
    return (
      <Dropdown
        loading
        placeholder="Select Name"
        name={props.name}
        {...props}
      />
    );
  } else {
    return sportList;
  }
};

const mapStateToProps = (state) => {
  return {
    athletes: state.firestore.ordered.advocates,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
  ])
)(AdvocatesDropdown);
